import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, Route, Switch } from "react-router-dom";

import Localization from "../../localization";
import Button from "../../components/button";
import Profile from "./Profile";
import ProfileEdit from "./ProfileEdit";
import Spaces from "./Spaces";
import Artistics from "./Artistics";
import Claim from "./Claim";
import Technics from "./Technics";
import IconArrow from "../../components/icons/arrow";

import { loadFaq } from "../../redux/actions/faq";
import { logout } from "../../redux/actions/auth";
import { getUrl } from "../../utils/helper";
import { getMe } from "../../redux/selectors/me";
import {
    loadActiveOpenCalls,
    loadOpenCallApplications,
} from "../../redux/actions/openCalls";

class Account extends Component {
    constructor(props) {
        super(props);

        this._onLogoutPress = this._onLogoutPress.bind(this);
    }

    componentDidMount() {
        this.props.loadFaq();
        this.props.loadActiveOpenCalls();
        this.props.loadOpenCallApplications();
    }

    _onLogoutPress() {
        this.props.logout();
        this.props.history.replace(getUrl());
    }

    _renderMenuButton(title, url, activeUrls = []) {
        const { match } = this.props;

        let active = match.url === url;
        if (!active) {
            activeUrls.forEach((activeUrl) => {
                if (match.url === activeUrl) {
                    active = true;
                }
            });
        }

        return (
            <Button
                text={title}
                textStyle={
                    active
                        ? "font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-white"
                        : "font-bold text-20 xl:text-23 z-10 text-center transition hover-hover:group-hover:text-white text-blue"
                }
                style="mb-12"
                wrapperStyle="px-15"
                backgroundColor={active ? "bg-blue" : "bg-grey"}
                to={url}
            />
        );
    }

    _renderMenu() {
        const { locale, user } = this.props;

        return (
            <div className="hidden xl:flex flex-col w-3/12">
                <p className="text-30 font-judge font-bold">
                    {Localization[locale].account.my_account}
                </p>
                <div className="mt-40">
                    {this._renderMenuButton(
                        Localization[locale].account.profile,
                        getUrl("account/profile"),
                        [getUrl("account/profile/edit")]
                    )}
                    {this._renderMenuButton(
                        Localization[locale].account.artistic,
                        getUrl("account/artistic")
                    )}
                    {this._renderMenuButton(
                        Localization[locale].account.technical,
                        getUrl("account/technical")
                    )}
                    {user &&
                        this._renderMenuButton(
                            Localization[locale].account.reclamar_tempo,
                            getUrl("account/claim")
                        )}
                    {user &&
                        user.is_local &&
                        this._renderMenuButton(
                            Localization[locale].account.reservation,
                            getUrl("account/spaces")
                        )}
                    <Button
                        text={Localization[locale].account.logout}
                        textStyle={
                            "font-bold text-23 z-10 transition hover-hover:group-hover:text-white text-blue"
                        }
                        backgroundColor={"bg-grey w-full"}
                        onClick={this._onLogoutPress}
                        wrapperStyle="px-15"
                    />
                </div>
            </div>
        );
    }

    _renderMenuMobile() {
        const { locale, user } = this.props;

        const profileUrl = getUrl("account/profile");
        const editProfileUrl = getUrl("account/profile/edit");
        const artisticUrl = getUrl("account/artistic");
        const technicalUrl = getUrl("account/technical");
        const claimUrl = getUrl("account/claim");
        const spacesUrl = getUrl("account/spaces");

        let active = false;
        if (
            location.pathname.includes(profileUrl) ||
            location.pathname.includes(editProfileUrl) ||
            location.pathname.includes(artisticUrl) ||
            location.pathname.includes(technicalUrl) ||
            location.pathname.includes(claimUrl) ||
            location.pathname.includes(spacesUrl)
        ) {
            active = true;
        }

        if (active || !user) return null;

        return (
            <div className="xl:hidden flex-col w-full">
                <div className="flex">
                    <p className="text-34 flex-1 font-judge font-bold">
                        {Localization[locale].account.my_account}
                    </p>
                    <p className="shrink-0 text-20 text-right font-judge font-bold text-orange w-150">
                        {user.available_quota +
                            " " +
                            Localization[locale].account.available_quota}
                    </p>
                </div>
                <div className="flex flex-col mt-40">
                    <div className="flex border-t border-blue items-center">
                        <Link
                            to={getUrl("account/profile")}
                            className={
                                "text-17 font-judge font-bold py-12 flex-1"
                            }
                            title={Localization[locale].account.profile}
                        >
                            {Localization[locale].account.profile}
                        </Link>
                        <IconArrow className="cursor-pointer transform rotate-90" />
                    </div>

                    <div className="flex border-t border-blue items-center">
                        <Link
                            to={getUrl("account/artistic")}
                            className={
                                "text-17 font-judge font-bold py-12 flex-1"
                            }
                            title={Localization[locale].account.artistic}
                        >
                            {Localization[locale].account.artistic}
                        </Link>
                        <IconArrow className="cursor-pointer transform rotate-90" />
                    </div>

                    <div className="flex border-t border-blue items-center">
                        <Link
                            to={getUrl("account/technical")}
                            className={
                                "text-17 font-judge font-bold py-12 flex-1"
                            }
                            title={Localization[locale].account.technical}
                        >
                            {Localization[locale].account.technical}
                        </Link>
                        <IconArrow className="cursor-pointer transform rotate-90" />
                    </div>

                    {user && (
                        <div className="flex border-t border-blue items-center">
                            <Link
                                to={getUrl("account/claim")}
                                className={
                                    "text-17 font-judge font-bold py-12 flex-1"
                                }
                                title={
                                    Localization[locale].account.reclamar_tempo
                                }
                            >
                                {Localization[locale].account.reclamar_tempo}
                            </Link>
                            <IconArrow className="cursor-pointer transform rotate-90" />
                        </div>
                    )}

                    {user && user.is_local && (
                        <div className="flex border-t border-blue items-center">
                            <Link
                                to={getUrl("account/spaces")}
                                className={
                                    "text-17 font-judge font-bold py-12 flex-1"
                                }
                                title={Localization[locale].account.reservation}
                            >
                                {Localization[locale].account.reservation}
                            </Link>
                            <IconArrow className="cursor-pointer transform rotate-90" />
                        </div>
                    )}
                    <div className="flex border-t border-b border-blue items-center">
                        <Link
                            onClick={this._onLogoutPress}
                            className={
                                "text-17 font-judge font-bold py-12 flex-1"
                            }
                            title={Localization[locale].account.logout}
                        >
                            {Localization[locale].account.logout}
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let className = "bg-grey flex xl:pt-60 pb-60 xl:pb-100 px-16 xl:px-50";
        if (
            location.pathname.includes(getUrl("account/profile")) ||
            location.pathname.includes(getUrl("account/profile/edit")) ||
            location.pathname.includes(getUrl("account/artistic")) ||
            location.pathname.includes(getUrl("account/claim")) ||
            location.pathname.includes(getUrl("account/spaces")) ||
            location.pathname.includes(getUrl("account/technical"))
        ) {
            className += " " + "pt-30 xl:mt-140";
        } else {
            className += " " + "pt-40 mt-100 xl:mt-140";
        }

        return (
            <div className={className}>
                {this._renderMenu()}
                {this._renderMenuMobile()}
                <div className="xl:w-1/12" />
                <div className="flex-1 xl:w-8/12">
                    <Switch>
                        <Route
                            exact
                            path={"/:lang/account/profile"}
                            component={Profile}
                        />
                        <Route
                            exact
                            path={"/:lang/account/profile/edit"}
                            component={ProfileEdit}
                        />
                        <Route
                            exact
                            path={"/:lang/account/artistic"}
                            component={Artistics}
                        />
                        <Route
                            exact
                            path={"/:lang/account/claim"}
                            component={Claim}
                        />
                        <Route
                            exact
                            path={"/:lang/account/technical"}
                            component={Technics}
                        />
                        <Route
                            exact
                            path={"/:lang/account/spaces"}
                            component={Spaces}
                        />
                    </Switch>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
    user: getMe(state),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            logout,
            loadFaq,
            loadOpenCallApplications,
            loadActiveOpenCalls,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Account);
